import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {getCustomFieldsForAccounts} from '../../../../store/data/customFields/customFieldsSelectors';
import {getAccountDomainAssociationJobs} from '../../../../store/data/jobs/jobsSelectors';
import {getIsUserGlobalAdmin} from '../../../../store/data/teammates/teammatesSelectors';
import {navigateToLinkAction} from '../../../../store/stateless/navigationActions';
import {AddAccountInformationPopover} from './addAccountInformationPopover';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  customFieldsMap: getCustomFieldsForAccounts,
  isUserGlobalAdmin: getIsUserGlobalAdmin,
  jobs: getAccountDomainAssociationJobs,
}));

const mapDispatchToProps = {
  onNavigateToCustomFieldsSettings: () =>
    navigateToLinkAction('/settings/global/custom-fields/accounts/overview'),
};

export const AddAccountInformationPopoverContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddAccountInformationPopover);
